module.exports = __webpack_public_path__ + "media/img/jewel-0c05eb882f8c267de2d8c4141f54cb19.png";